import { AuthenticationConfig } from '@core-argos-angular-artifact/core';

export const getKcConfig = (config: any): AuthenticationConfig => {
  return {
    env: config.env,
    config: config.keycloak.config,
    init: {
      ...config.keycloak.init,
      silentCheckSsoRedirectUri: `${document.location.origin}/assets/html/silent-check-sso.html`
    },
    login: config.keycloak.login,
    logout: config.keycloak.logout
  };
};
